export default __webpack_public_path__ + "images/__.27b6cba.png";